//External Libraries
import { CMButton } from '@chartmetric/chartmetric-design-system/components/CMButton';
import { CMIcon } from '@chartmetric/chartmetric-design-system/components/CMIcon';
import { faHeart as farHeart } from '@fortawesome/pro-regular-svg-icons/faHeart';
import { faThumbsUp as farThumbsUp } from '@fortawesome/pro-regular-svg-icons/faThumbsUp';
import { faFaceMeh as farFaceMeh } from '@fortawesome/pro-regular-svg-icons/faFaceMeh';
import { faFaceFrownSlight as farFaceFrownSlight } from '@fortawesome/pro-regular-svg-icons/faFaceFrownSlight';
import { faThumbsDown as farThumbsDown } from '@fortawesome/pro-regular-svg-icons/faThumbsDown';
import { faHeart as fasHeart } from '@fortawesome/pro-solid-svg-icons/faHeart';
import { faThumbsUp as fasThumbsUp } from '@fortawesome/pro-solid-svg-icons/faThumbsUp';
import { faFaceMeh as fasFaceMeh } from '@fortawesome/pro-solid-svg-icons/faFaceMeh';
import { faFaceFrownSlight as fasFaceFrownSlight } from '@fortawesome/pro-solid-svg-icons/faFaceFrownSlight';
import { faThumbsDown as fasThumbsDown } from '@fortawesome/pro-solid-svg-icons/faThumbsDown';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

//Types
import type { ReactionType } from '../types';

const REACTION_ICONS_REGULAR: Record<ReactionType, IconDefinition> = {
  love: farHeart,
  thumbsup: farThumbsUp,
  smile: farFaceMeh,
  angry: farFaceFrownSlight,
  thumbsdown: farThumbsDown,
};

const REACTION_ICONS_SOLID: Record<ReactionType, IconDefinition> = {
  love: fasHeart,
  thumbsup: fasThumbsUp,
  smile: fasFaceMeh,
  angry: fasFaceFrownSlight,
  thumbsdown: fasThumbsDown,
};

const REACTION_ICON_CLASSES: Record<ReactionType, `text-cm-${string}`> = {
  love: 'text-cm-green-400',
  thumbsup: 'text-cm-warmgreen-500',
  smile: 'text-cm-orange-700',
  angry: 'text-cm-red-500',
  thumbsdown: 'text-cm-red-600',
};

interface ReactionIconButtonProps {
  type: ReactionType;
  count: number;
  isActive: boolean;
  isSubmitting: boolean;
  disabled?: boolean;
  onClick: () => void;
}

function ReactionIconButton({ type, count, isActive, isSubmitting, disabled = false, onClick }: ReactionIconButtonProps) {
  const icon = isActive ? REACTION_ICONS_SOLID[type] : REACTION_ICONS_REGULAR[type];
  return (
    <CMButton
      variant="secondaryText"
      iconLeft={<CMIcon icon={icon} color={REACTION_ICON_CLASSES[type]} />}
      text={count > 0 ? String(count) : '0'}
      onClick={onClick}
      disabled={isSubmitting || disabled}
      title={type}
      size="sm"
      _className={`flex-1 ${isActive ? 'scale-110' : 'hover:scale-105'} !text-cm-charcoal-2`}
    />
  );
}

export default ReactionIconButton;
